/** USD projections only. These calculations never enable a product or take payment. */
import { EVENT_PASS_SIZES, SUBSCRIPTION_PRICES } from "./offers";
export function calculatePricing({
  events,
  entries,
  entryFee,
  annual,
  passFees = false,
}: {
  events: number;
  entries: number;
  entryFee: number;
  annual: boolean;
  passFees?: boolean;
}) {
  if (
    !Number.isInteger(events) ||
    events < 0 ||
    events > 10000 ||
    !Number.isInteger(entries) ||
    entries < 1 ||
    entries > 1000000 ||
    !Number.isFinite(entryFee) ||
    entryFee < 0 ||
    entryFee > 1000000
  )
    throw new Error("Enter whole event and entry counts, and a non-negative entry fee.");
  const size = EVENT_PASS_SIZES.find((s) => s.entries >= entries);
  const freeEvents = entries <= 50 && entryFee === 0 ? Math.min(events, 2) : 0;
  const passCents = size ? (events - freeEvents) * size.usd * 100 : events === 0 ? 0 : null;
  const clubCents =
    (annual ? SUBSCRIPTION_PRICES.club.annual : SUBSCRIPTION_PRICES.club.monthly * 12) * 100;
  const tourCents =
    (annual ? SUBSCRIPTION_PRICES.tour.annual : SUBSCRIPTION_PRICES.tour.monthly * 12) * 100;
  // Round the per-entry amount, matching an advertised inclusive price in whole cents.
  const entryCents = Math.round(entryFee * 100);
  const fee = (rate: number) => (passFees ? 0 : Math.round(entryCents * rate) * entries * events);
  const scorioFeeCents = fee(0.03),
    liveheatsFeeCents = fee(0.04),
    livejudgeFeeCents = fee(0.025);
  const liveheatsPrices = [13200, 21500, 27500, 39600];
  const sizeIndex = EVENT_PASS_SIZES.findIndex((s) => s.key === size?.key);
  const liveheatsCents =
    sizeIndex >= 0 ? liveheatsPrices[sizeIndex] * events : events === 0 ? 0 : null;
  const livejudgeCents = (entries <= 10 ? 0 : Math.min(entries * 349, 29900)) * events;
  const totals = [
    { key: "pass", cents: passCents === null ? Infinity : passCents + scorioFeeCents },
    { key: "club", cents: clubCents + scorioFeeCents },
    { key: "tour", cents: tourCents },
  ];
  const cheapest = totals.reduce((best, row) => (row.cents < best.cents ? row : best)).key;
  return {
    size: size?.key ?? null,
    freeEvents,
    passCents,
    clubCents,
    tourCents,
    scorioFeeCents,
    liveheatsCents,
    livejudgeCents,
    liveheatsFeeCents,
    livejudgeFeeCents,
    cheapest,
    athleteScorioCents: entryCents + (passFees ? Math.round(entryCents * 0.03) : 0),
    athleteLiveheatsCents: entryCents + (passFees ? Math.round(entryCents * 0.04) : 0),
    athleteLivejudgeCents: entryCents + (passFees ? Math.round(entryCents * 0.025) : 0),
  };
}
